import * as React from 'react';

const Rectangle21Svg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <g
            id="rectangle-2-1_svg__rectangle-2-1"
            stroke="none"
            strokeWidth={1}
            fillRule="evenodd"
        >
            <path d="M3 8v8h18V8H3zM2 7h20v10H2V7z" fillRule="nonzero" />
        </g>
    </svg>
);

Rectangle21Svg.displayName = 'Rectangle21Svg';
export default Rectangle21Svg;
